
(function () {
    'use strict';

    angular.module('customeDirectivesModule')
        .directive('npSearchHomePage', npSearchHomePage)
        .directive('ngOptions', ['$timeout', ngOptions])
        ;

    function npSearchHomePage() {
        var directive = {
            restrict: 'EA',
            templateUrl: paths.SearchHomePageView,
            scope: {
                toggleSearhBoxHeader: '&toggleSearhBoxHeader',
            },
            link: linkFunction,
            controller: ['$scope', '$state', '$timeout', '$http', '$window', '$uibModal',
                'debounceService', 'stringValidationService', 'localStorageService', 'documentService', 'configService', controller],
            controllerAs: 'vm'
        };

        return directive;

        function linkFunction(scope, el, attr, ctrl) {
        };

        function controller($scope, $state, $timeout, $http, $window, $uibModal,
            debounceService, stringValidationService, localStorageService, documentService, configService) {
            var previousRequests = [];

            var vm = this;

            vm.translation = globalResources;
            vm.NormalSearchTooltip = globalResources.NormalSearchTooltip.replace('{0}', HandbookConfiguration.HomeSearchPopupSize);
            vm.SearchInContentTooltip = globalResources.SearchInContentTooltip.replace('{0}', HandbookConfiguration.HomeSearchPopupSize);
            vm.quickSearchKeyword;
            vm.documents = {};
            vm.isCurrentPage = true;
            vm.togglePopup = false;
            vm.currentItem = null;
            vm.currentIndex = -1;
            vm._scrollHeight = 0;
            vm.searchInContentLabel = $window.innerWidth > 550 ? vm.translation.CheckboxIncludeDocContent : vm.translation.Content;
            vm.SearchBoxPlaceHolder = globalResources.TitleSearchBoxPlaceholder;
            vm.enabledMetadataSearch = false;
            vm.enabledAdvanceSearch = false;
            vm.isMetadataSearch = configService.getBool(HandbookConfiguration.MetadataEnabled) && vm.enabledMetadataSearch;
            vm.isMessageInfo = false;
            vm.messageInfoBottom = String.format(vm.translation.ShowMessageInfoBottomListSearch, HandbookConfiguration.HomeSearchPopupSize);
            vm.doSearchDataMining = configService.getBool(HandbookConfiguration.DoSearchDataMining);
            vm.clearSearchToggle = configService.getBool(HandbookConfiguration.ClearSearchToggle);
            vm.searchInFolders = configService.getBool(HandbookConfiguration.SearchInFolders);
            vm.enableProcess = configService.getBool(HandbookConfiguration.EnableProcess);
            vm.enableVAR = configService.getBool(HandbookConfiguration.EnableVAR);

            vm.onSearch = debounceService.debounce(onSearch, 500);
            vm.onDataNavigating = onDataNavigating;
            vm.hidePopupOnLostFocus = hidePopupOnLostFocus;
            vm.goToDocument = goToDocument;
            vm.goToFolder = goToFolder;
            vm.openAdvancedSearch = openAdvancedSearch;
            vm.searchDocument = searchDocument;
            vm.clear_Keyword = clear_Keyword;
            vm.changeSearchKeyword = changeSearchKeyword;
            vm.openMetadataSearch = openMetadataSearch;
            vm.popupMouseDown = popupMouseDown;
            vm.popupMouseUp = popupMouseUp;
            vm.goToProcess = goToProcess;
            vm.goToProcessArea = goToProcessArea;
            vm.onVARClick = onVARClick;

            vm.key_showRemoveIcon = false;
            vm.noMatches = false;
            vm.activePopup = false;
            vm.searchMode = "0";
            vm.toggleSearhBoxHeader = toggleSearhBoxHeader;
            vm.varRecords = [];
            vm.numFoundOfVar = 0;

            initialize();

            $scope.$on(broadcastType.resetQuickSearchKeyword, function (e, target) {
                vm.quickSearchKeyword = '';
            });

            function initialize() {
                if (!vm.clearSearchToggle) {
                    var searchMode = localStorageService.getItem('SearchMode');
                    vm.searchMode = searchMode == null ? 0 : (searchMode == 1 ? 1 : 0);
                }
            }

            function toggleSearhBoxHeader() {
                vm.quickSearchKeyword = "";
                // mobile view
                $scope.toggleSearhBoxHeader();
            }

            function onSearch(keyEvent) {              
                if (keyEvent.which == KEY_CODES.ESCAPE) {
                    resetCurrentItem();
                    vm.quickSearchKeyword = '';
                    hidePopupOnLostFocus();
                }
                else if (keyEvent.which == KEY_CODES.ENTER) {
                    if (vm.currentItem == null) {
                        searchDocument();
                    }
                    else {
                        if (vm.currentIndex < vm.documents.length) {
                            vm.goToDocument(vm.currentItem);
                        }
                        else {
                            vm.goToFolder(vm.currentItem.id);
                        }

                        vm.togglePopup = false;
                        resetCurrentItem();
                        vm.quickSearchKeyword = '';
                    }
                }
                else if (keyEvent.which != KEY_CODES.UP_ARROW && keyEvent.which != KEY_CODES.DOWN_ARROW && keyEvent.which != KEY_CODES.ESCAPE) {
                    onSearchInputChanged();
                    resetCurrentItem();
                }
            }

            function onDataNavigating(keyEvent) {
                if (keyEvent.which == 38 || keyEvent.which == 40) {
                    setcurrentItemInPopup(keyEvent.which);
                }
            };

            function searchDocument() {
                var keywordValue = vm.quickSearchKeyword ? vm.quickSearchKeyword.trim() : '';
                vm.isCurrentPage = false;
                vm.togglePopup = false;
                $state.go(handbookActions.SearchResultAction, {
                    keyword: keywordValue,
                    searchInContents: vm.searchMode,
                    folderId: null,
                    fromDate: null,
                    toDate: null,
                    type: vm.searchMode == 1 ? 2 : 1
                });
                vm.quickSearchKeyword = '';

                toggleSearhBoxHeader();
            };

            function getProcessSearchResult(keyword, searchType) {
                var processRequestParams = {
                    keyword: keyword,
                    searchType: searchType,
                    isFrontend: true,
                    isContentSearch: vm.searchInContents
                };

                $http.get(handbookRequests.SearchProcesses, { params: processRequestParams })
                    .then(function (response) {
                        if (response != null && response.data != null && response.data.length) {
                            vm.processes = response.data;
                            if (vm.processes.length > parseInt(HandbookConfiguration.HomeSearchPopupSize)) {
                                vm.processes = vm.processes.slice(0, parseInt(HandbookConfiguration.HomeSearchPopupSize));
                            }
                        }
                    });

                $http.get(handbookRequests.SearchProcessAreas, { params: processRequestParams })
                    .then(function (response) {
                        if (response != null && response.data != null && response.data.length) {
                            vm.processAreas = response.data;
                            if (vm.processAreas.length > parseInt(HandbookConfiguration.HomeSearchPopupSize)) {
                                vm.processAreas = vm.processAreas.slice(0, parseInt(HandbookConfiguration.HomeSearchPopupSize));
                            }
                        }
                    });
            }

            function onSearchInputChanged() {
                var searchCondition = vm.quickSearchKeyword != null
                    && vm.quickSearchKeyword != ''
                    && (vm.quickSearchKeyword.length > 1 || !isNaN(vm.quickSearchKeyword))
                    && vm.isCurrentPage
                    && stringValidationService.notContainSpecialCharacter(vm.quickSearchKeyword)
                    && (vm.searchMode == 0);

                if (searchCondition) {

                    if (vm.enableProcess) {
                        vm.processes = [];
                        vm.processAreas = [];
                        getProcessSearchResult(vm.quickSearchKeyword, E.searchType.Popup);
                    }

                    if (vm.enableVAR) {
                        searchVAR(vm.quickSearchKeyword);
                    }

                    var searchRequestParams = {
                        keyword: vm.quickSearchKeyword,
                        searchInContents: vm.searchMode == 1 ? true : false,
                        searchType: E.searchType.Popup
                    };

                    var requestId = previousRequests.length + 1;
                    previousRequests.push(requestId);

                    $http.get(handbookRequests.SearchRequest, { params: searchRequestParams, requestId: requestId })
                        .then(function (response, status, headers, config) {
                            //only accept result set that belongs to lastest request
                            if (previousRequests[previousRequests.length - 1] != response.config.requestId) {
                                return;
                            }

                            vm.documents = response.data.documents.filter(x => !x.hidden);
                            if (vm.documents && vm.documents.length > parseInt(HandbookConfiguration.HomeSearchPopupSize)) {
                                vm.documents = vm.documents.slice(0, parseInt(HandbookConfiguration.HomeSearchPopupSize));
                            }
                            vm.folders = response.data.folders.filter(x => !x.hidden);
                            if (vm.folders && vm.folders.length > parseInt(HandbookConfiguration.HomeSearchPopupSize)) {
                                vm.folders = vm.folders.slice(0, parseInt(HandbookConfiguration.HomeSearchPopupSize));
                            }
                            vm.togglePopup = ((vm.documents != null && vm.documents.length) > 0 || (vm.folders != null && vm.folders.length > 0));
                            vm.noMatches = !vm.togglePopup;
                            vm.isMessageInfo = (response.data.totalCount != null && response.data.totalCount > parseInt(HandbookConfiguration.HomeSearchPopupSize));
                        });
                }
                else {
                    $scope.$apply(function () {
                        vm.togglePopup = false;
                    });
                    vm.isCurrentPage = true;
                }
            };

            function setcurrentItemInPopup(keyCode) {
                var lengthFolder = vm.folders != null ? vm.folders.length : 0;
                if (keyCode == 38 && vm.currentIndex > 0) {
                    //go up
                    vm.currentIndex -= 1;
                    vm._scrollHeight -= 50;
                }
                if (keyCode == 40 && vm.currentIndex < (vm.documents.length + lengthFolder) - 1) {
                    //go down
                    vm.currentIndex += 1;
                    vm._scrollHeight += 50;
                }
                angular.element('#search-popup-identifier')[0].scrollTop = vm._scrollHeight;

                if (vm.currentIndex < vm.documents.length) {
                    vm.currentItem = vm.documents[vm.currentIndex];
                }
                else {
                    vm.currentItem = vm.folders[vm.currentIndex - vm.documents.length];
                }
            };

            function resetCurrentItem() {
                vm.currentItem = null;
                vm.currentIndex = -1;
                vm._scrollHeight = 0;
            };

            function hidePopupOnLostFocus() {
                $timeout(function () {
                    if (!vm.activePopup) {
                        vm.togglePopup = false;
                    }
                    vm.noMatches = false;
                }, 200);
            };

            function changeSearchKeyword() {
                vm.key_showRemoveIcon = (vm.quickSearchKeyword != undefined && vm.quickSearchKeyword.length > 0);
            }
            function clear_Keyword() {
                vm.quickSearchKeyword = '';
                vm.key_showRemoveIcon = false;
            };

            function goToDocument(document) {
                toggleSearhBoxHeader();
                if (!document.isCompendiaDocument) {
                    insertLogWords(document.id);
                    documentService.goToDocument(document.id, document.defaultFieldView);
                } else {
                    window.open(document.compendiaDocumentLink);
                }
            };

            function goToFolder(id) {
                toggleSearhBoxHeader();
                $state.go(handbookActions.FolderAction, { folderId: id });
            }

            function goToProcess(processNumber) {
                toggleSearhBoxHeader();
                $state.go('process-detail', { processNumber: processNumber });
            }

            function goToProcessArea(id) {
                toggleSearhBoxHeader();
                $state.go('process-area-detail', { areaId: id });
            }

            function insertLogWords(documentId) {
                if (!vm.doSearchDataMining) {
                    return;
                }
                return $http.post('/api/Search/LogSearchWords',
                    {
                        documentId: documentId,
                        employeeId: user.userId,
                        searchKey: vm.quickSearchKeyword,
                        searchType: 1,
                        searchFilters: ''
                    }).then(function (data, status, headers, config) {
                        return true;
                    });
            }

            function openAdvancedSearch() {
                var modalInstance = $uibModal.open({
                    templateUrl: paths.AdvancedSearchModalView,
                    controller: controllers.advanceSearchController,
                    size: 'sm',
                    resolve: {
                        quickSearchKeyword: function () {
                            return vm.quickSearchKeyword;
                        }
                    }
                });
            };

            function openMetadataSearch() {
                var modalInstance = $uibModal.open({
                    templateUrl: '/app/shared/searchAdvanceModule/metadataSearchModalView.html',
                    controller: controllers.metadataController,
                    size: 'sm',
                    resolve: {
                        quickSearchKeyword: function () {
                            return vm.quickSearchKeyword;
                        }
                    }
                });
            };

            function popupMouseDown() {
                vm.activePopup = true;
            }

            function popupMouseUp() {
                vm.activePopup = false;
                vm.togglePopup = false;
            }

            function onVARClick(row) {
                window.open(row.url);
            }

            function searchVAR(keyword) {
                if (vm.isLoadingVar) return;
                vm.isLoadingVar = true;

                return $http.get('/api/var/', {
                    params: {
                        method: 'PROCEDURE',
                        query: keyword,
                        offset: 0
                    }
                }).then(response => {
                    if (!response || !response.data || !response.data.documents || !response.data.documents.length) return;
                    vm.numFoundOfVar = response.data.numFound;
                    vm.varRecords = (response.data.documents || []).slice(0, 10);
                }).finally(() => {
                    vm.isLoadingVar = false;
                });       
            }
        }
    }

    function ngOptions($timeout) {
        return {
            priority: 1,
            require: 'ngModel',
            link: function (scope, ele, attrs, ctrl) {
                var isIE = false;
                if (navigator.appName == 'Microsoft Internet Explorer') {
                    var ua = navigator.userAgent;
                    var re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
                    if (re.exec(ua) != null) {
                        isIE = true;
                    }
                }
                if (isIE) {
                    //to fix IE8 issue with parent and detail controller, we need to depend on the parent controller
                    var control = ele[0];
                    var options = attrs.ngOptions;
                    var match = options.match(/^\s*(.*?)(?:\s+as\s+(.*?))?(?:\s+group\s+by\s+(.*))?\s+for\s+(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+(.*?)(?:\s+track\s+by\s+(.*?))?$/);

                    if (match && match[7]) {
                        var dataSource = match[7];
                        scope.$watch(dataSource, function (value) {
                            //this will add and remove the options to trigger the rendering in IE9
                            if (value) {
                                var option = document.createElement("option");
                                control.add(option, null);
                                control.remove(control.options.length - 1);
                            }
                        });
                    }
                }
            }
        }
    };
})();
